<template>
  <div class="home">
    <NavbarMain />
    <div
      class="alert alert-danger mt-2"
      role="alert"
      v-if="product.msgCancel && product.msgCancel != 'undefined'"
    >
      {{ product.msgCancel }}
    </div>
    <h1 class="text-center mb-5 mt-5">Editar {{ name }}</h1>
    <div class="container mt-5">
      <DetailPublication
        kind="servicio"
        :name="product.name"
        :description="product.description"
        :categorySelected="product.category._id"
        v-on:handleChangeName="handleChangeName"
        v-on:handleChangeDescription="handleChangeDescription"
        v-on:handleChangeCategory="handleChangeCategory"
      />

      <SpecsPublication
        kind="servicio"
        :productSpecs="product.specs"
        v-on:handleChangeSpec="handleChangeSpec"
        v-on:initSpecs="initSpecs"
      />

      <ImagesPublication
        :images="product.images"
        :id="product._id"
        kind="servicio"
        v-on:handleChangeImages="handleChangeImages"
      />

      <VideoPublication
        :videoYT="product.videoYT"
        v-on:handleChangeVideoYT="handleChangeVideoYT"
      />

      <SellerPlacePublication
        kind="servicio"
        :sellerPlaceWorld="product.sellerPlaceWorld"
        :sellerPlaces="product.sellerPlaces"
        :CityOfSale="product.CityOfSale"
        v-on:handleChangeTypePlace="handleChangeTypePlace"
      />

      <PricePublication
        kind="servicio"
        :currency="product.currency"
        :price="product.price"
        :discount="product.discount"
        :comision="product.category.crr"
        v-on:handleChangePrice="handleChangePrice"
        v-on:handleChangeCurrency="handleChangeCurrency"
        v-on:handleChangeDiscount="handleChangeDiscount"
      />

      <span class="btn btn-block btn-treid mb-5" @click="updateProduct">
        <div class="spinner-border" role="status" v-if="onload">
          <span class="sr-only">Loading...</span>
        </div>
        <span v-else>Aplicar</span>
      </span>

      <StatePublication kind="servicio" :id="product._id" />
    </div>
    <ModalNotify
      :visible="modalNotify.visible"
      :success="modalNotify.success"
      :title="modalNotify.title"
      :body="modalNotify.body"
      :acept="modalNotify.acept"
      :return="modalNotify.return"
      v-on:click="handleClickModal"
      v-on:clickReturn="handleCloseModal"
    />
  </div>
</template>

<script>
import Api from "../../tools/Api2";
import NavbarMain from "@/components/NavbarMain.vue";
import ModalNotify from "../../components/modals/ModalNotify";
import { mapState, mapMutations } from "vuex";
import DetailPublication from "../../components/publication/DetailPublication.vue";
import SpecsPublication from "../../components/publication/SpecsPublication.vue";
import VideoPublication from "../../components/publication/VideoPublication.vue";
import SellerPlacePublication from "../../components/publication/SellerPlacePublication.vue";
import PricePublication from "../../components/publication/PricePublication.vue";
import ImagesPublication from "../../components/publication/ImagesPublication.vue";
import StatePublication from "../../components/publication/StatePublication.vue";
export default {
  name: "PublicationService",
  components: {
    NavbarMain,
    ModalNotify,
    DetailPublication,
    SpecsPublication,
    VideoPublication,
    SellerPlacePublication,
    PricePublication,
    ImagesPublication,
    StatePublication,
  },
  data() {
    return {
      product: {
        category: {
          _id: "0",
        },
        description: "",
        name: "",
        price: 0,
        sellerId: "",
        images: ["blank.png"],
        discount: 0,
      },
      /* ------------ */
      modalNotify: {
        visible: false,
        success: false,
        title: "Ups, algo salio mal!",
        body: "hubo un problema al cancelar el servicio",
        return: false,
        redirect: "/mis-publicaciones",
        acept: false,
      },
      onload: false,
      name: "",
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  created: async function () {
    Api("service")
      .get(this.$route.params.id)
      .then((res) => {
        if (this.auth.id != res.service.sellerId._id)
          return this.$router.push({ name: "Home" });

        this.product = res.service;
        this.name = res.service.name;
      });
  },
  methods: {
    ...mapMutations(["setAuth"]),
    handleChangeName(name) {
      this.product.name = name;
    },
    handleChangeDescription(description) {
      this.product.description = description;
    },
    handleChangeCategory(category) {
      this.product.category = category;
    },
    handleChangeVideoYT(videoYT) {
      this.product.videoYT = videoYT;
    },
    handleChangeTypePlace({ sellerPlaceWorld, sellerPlaces, CityOfSale }) {
      this.product.sellerPlaceWorld = sellerPlaceWorld;
      this.product.sellerPlaces = sellerPlaces;
      this.product.CityOfSale = CityOfSale;
    },
    handleChangePrice(price) {
      this.product.price = price;
    },
    handleChangeCurrency(currency) {
      this.product.currency = currency;
    },
    handleChangeDiscount(discount) {
      if (discount > 100) return (this.product.discount = 100);

      if (discount < 0) return (this.product.discount = 0);

      this.product.discount = Number(discount);
    },
    handleChangeImages(images) {
      this.product.images = images;
    },
    initSpecs(specs) {
      this.product.specs = specs;
    },
    handleChangeSpec(position, spec) {
      this.product.specs[position] = {
        ...this.product.specs[position],
        ...spec,
      };
    },
    handleCloseModal() {
      this.modalNotify.visible = false;
    },
    handleClickModal() {
      this.$router.push({ name: "Publications" });
    },

    updateProduct() {
      const specs = this.product.specs
        .filter((e) => e.cheked)
        .map((e) => {
          return {
            value: e.value,
            options: e.selectable ? e.options : "",
            formCategory: e._id,
          };
        });
      this.onload = true;
      const patchProduct = {
        ...this.product,
        category: this.product.category._id,
        specs,
      };

      // Eliminamos las props que no son necesarias enviar;
      delete patchProduct._id;
      delete patchProduct.creationDate;
      delete patchProduct.msgCancel;
      delete patchProduct.sellerId;
      delete patchProduct.state;
      delete patchProduct.images;

      Api("service")
        .patch(this.product._id, patchProduct)
        .then((res) => {
          this.onload = false;
          if (!res.error) {
            this.modalNotify.title = "Publicacion actualizada!";
            this.modalNotify.body =
              "la publicacion ha sido actualizada con exito";
            this.modalNotify.return = false;
            this.modalNotify.acept = true;
          } else {
            this.modalNotify.title = "Ups, algo salio mal!";
            this.modalNotify.body = `hubo un problema al actualizar la publicación. ${
              res.error ? res.error : ""
            }<br/><br/>${res.message}`;
            this.modalNotify.return = true;
            this.modalNotify.acept = false;
          }
          this.modalNotify.visible = true;
          this.modalNotify.success = !res.error;
          this.isLoadCancel = false;
        });
    },
  },
};
</script>